import React from "react";
import tw from "tailwind-styled-components";

const CheckBoxWrapper = tw.input`
focus:ring-sky-500 h-4 w-4 text-sky-600 border-gray-300 rounded
`;

export default function Checkbox(props) {
  return <CheckBoxWrapper {...props} />;
}
